document.addEventListener('DOMContentLoaded', () => {
  let currentPage = 1;
  const maxPages = parseInt(document.querySelector('#product-grid').dataset.maxPages, 10);
  const productGrid = document.getElementById('product-grid');
  const loadingSpinner = document.createElement('div');
  loadingSpinner.className = 'loading-spinner';
  document.body.appendChild(loadingSpinner);

  let isLoading = false; // 标志：是否正在加载

  const loadMoreProducts = () => {
    if (isLoading || currentPage >= maxPages) return;

    isLoading = true; // 设置加载标志
    loadingSpinner.classList.add('active'); // 显示加载动画

    const nextPage = currentPage + 1;
    const url = `${window.location.pathname}?page=${nextPage}`;

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelector('#product-grid').innerHTML;

        // 插入新产品到现有网格
        productGrid.insertAdjacentHTML('beforeend', newProducts);

        // 为新加载的产品添加动画（可选）
        document.querySelectorAll('#product-grid .grid__item:not(.loaded)').forEach(item => {
          item.classList.add('loaded');
        });

        currentPage = nextPage;

        if (currentPage >= maxPages) {
          window.removeEventListener('scroll', handleScroll); // 移除滚动监听
        }
      })
      .catch(err => console.error('Error loading more products:', err))
      .finally(() => {
        isLoading = false; // 重置加载标志
        loadingSpinner.classList.remove('active'); // 隐藏加载动画
      });
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY + window.innerHeight;
    const bottomPosition = document.documentElement.scrollHeight - 200; // 距离底部 200px 时加载

    if (scrollPosition >= bottomPosition) {
      loadMoreProducts();
    }
  };

  window.addEventListener('scroll', handleScroll);
});